import React, { useState, Suspense } from 'react';
import TopBar from './TopBar';
import SideDrawer from './SideDrawer';
import BottomDock from './BottomDock';
import GlobalSearchPalette from './GlobalSearchPalette';
import TrialBanner from '../TrialBanner';
import ImpersonationBanner from '../ImpersonationBanner';
import PWAInstallBanner from '../PWAInstallBanner';
import PageFallback from '../PageFallback';

/**
 * Cut2Pro premium nav shell.
 *
 * 3-layer navigation:
 *   • TopBar (sticky)        — hamburger + logo + search/tickets/alerts/theme/profile
 *   • SideDrawer (☰)         — secondary admin/utility links
 *   • BottomDock (mobile)    — Sampling · Costing · PO · Cutting · Production · Packing · Finance
 *
 * Desktop (≥lg) hides the dock; the drawer is the only nav.
 */
export default function AppShell({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <div className="min-h-screen bg-stone-50 dark:bg-stone-950 text-stone-900 dark:text-stone-100">
      <ImpersonationBanner />
      <TrialBanner />
      <PWAInstallBanner />

      <TopBar
        onMenuClick={() => setDrawerOpen(true)}
        onSearchClick={() => setSearchOpen(true)}
      />

      {/* Main content — pad bottom so the dock + safe-area never overlap the
          last row. We use a calc() that combines fixed dock height (~7rem)
          with the device safe-area-inset, so on Android gesture nav phones
          and iPhones with home indicator the dock stays cleanly above content
          even when its auto-hide-on-scroll-down isn't triggered. */}
      <main
        style={{ paddingBottom: 'calc(7.5rem + env(safe-area-inset-bottom, 0px))' }}>
        {/* Suspense sits INSIDE the shell so lazily-loaded route chunks only
            swap the content area — TopBar / drawer / dock stay mounted. */}
        <Suspense fallback={<PageFallback />}>
          {children}
        </Suspense>
      </main>

      <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <BottomDock />
      <GlobalSearchPalette open={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
  );
}
